import { render, staticRenderFns } from "./OnboardingSuccess.vue?vue&type=template&id=a79cfcb6&scoped=true&"
import script from "./OnboardingSuccess.vue?vue&type=script&lang=ts&"
export * from "./OnboardingSuccess.vue?vue&type=script&lang=ts&"
import style0 from "./OnboardingSuccess.vue?vue&type=style&index=0&id=a79cfcb6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a79cfcb6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
